/* eslint-disable */

/*  Section.js  --------------------------------------------------- */
import React from "react";
import { Grid } from "@material-ui/core"; // ajuste para o seu alias
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

export const Section = ({ title, clientColor, children }) => (
  <Grid item xs={12} style={{marginTop: "-10px"}}>
    <Paper
      elevation={0}
      style={{
        padding: 18,
        marginBottom: 6,
        boxShadow: "0px 1px 3px rgba(0,0,0,0.12)",
      }}
    >
      <Typography
        variant="subtitle1"
        style={{
          fontWeight: 600,
          color: clientColor,
          marginBottom: 4,
          textTransform: "uppercase",
          letterSpacing: 0.5,
        }}
      >
        {title}
      </Typography>

      <Divider style={{ marginBottom: 14 }} />
      <Grid container spacing={2} style={{ marginTop: 7, marginLeft: 1, paddingRight: 14 }}>
        {children}
      </Grid>
    </Paper>
  </Grid>
);
